import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-692ebf48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-content-video__wrapper" }
const _hoisted_2 = ["src", "poster"]
const _hoisted_3 = {
  key: 1,
  class: "hd-content-video__placeholder placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-content-video", `hd-content-video__${_ctx.endpointId}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.videoSource)
        ? (_openBlock(), _createElementBlock("video", {
            key: 0,
            src: _ctx.videoSource,
            width: "1024",
            ref: "video",
            controls: "",
            poster: _ctx.posterSource
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_image_svg, {
              source: require('!html-loader!../../assets/icons/play-circle.svg'),
              class: "hd-content-video__placeholder-icon"
            }, null, 8, ["source"])
          ]))
    ])
  ], 2))
}